class GestaoIntegradaItens {
    static get $inject() {
        return ['$scope', '$uibModal', 'gql', 'downloadService']
    }

    constructor(scope, modal, gql, downloadService) {
        this.broadcast = (...args) => scope.$broadcast(...args)
        this.apply = fn => scope.$apply(fn)
        this.modal = modal
        this.gql = gql
        this.downloadService = downloadService

        scope.$on('changeFilter', (_event, filter) =>
            this.filter = { ...this.filter, ...filter }
        )
    }

    exportFornecedoresSugeridos(filialId) {
        const query = gql`
            query($filialId: Int!) {
                filial(id: $filialId) {
                    id
                    operation: codigosFornecedoresSugeridosReport {
                        token
                    }
                }
            }
        `

        this.downloadService
            .resumeOperation(() => {
                const variables = {
                    filialId: parseInt(filialId)
                }

                return this.gql
                    .query(query, variables)
                    .then(({ filial: { operation } }) => operation)
            })
    }

    openCadastroModal(filialId) {
        this.modal
            .open({
                backdrop: 'static',
                size: 'lg',
                component: 'produtoCadastroModal',
                resolve: {
                    filialId: () => filialId,
                    empresaId: () => this.empresaId
                }
            })
            .result.then(({ produto }) => {
                this.broadcast("novoProduto", produto)
            })
    }

    openImportacaoCodigosModal(filialId) {
        this.modal
            .open({
                backdrop: 'static',
                size: 'md',
                component: 'importacaoCodigosFornecedoresModal',
                resolve: {
                    filialId: () => filialId,
                    empresaId: () => this.empresaId
                }
            })
    }
    
    openProdutoDuplicadoModal(produto) {
        this.modal.open({
                component: 'produtoDuplicadoModal',
                backdrop: 'static',
                size: 'xl',
                resolve: {
                    empresaId: () => this.empresaId,
                    produto: () => produto
                }
            })
    }
}

angular.module("eficienciaFiscalModule")
    .component("gestaoIntegradaItens", {
        controller: GestaoIntegradaItens,
        bindings: {
            empresaId: '<'
        },
        template: `
            <div>
                <operations-toolbar>
                    <right>
                        <button
                            class="btn btn-default"
                            ng-click="$ctrl.openProdutoDuplicadoModal()">
                            <i class="fa fa-cubes"></i>
                            Produtos duplicados
                        </button> 
                        <button
                            class="btn btn-default"
                            ng-click="$ctrl.exportFornecedoresSugeridos($ctrl.filter.filialId)">
                            <i class="fa fa-download"></i>
                            Exportar códigos de fornecedores sugeridos
                        </button> 
                        <button
                            class="btn btn-default"
                            ng-click="$ctrl.openImportacaoCodigosModal($ctrl.filter.filialId)"
                            ng-disabled="!$ctrl.filter.filialId">
                            <i class="fa fa-upload"></i>
                            Importar códigos de fornecedores
                        </button>
                    </right>
                </operations-toolbar>
                
                <produto-filter empresa-id="$ctrl.empresaId" ng-model="$ctrl.filter">
                </produto-filter>
                <produto-list empresa-id="$ctrl.empresaId" filter="$ctrl.filter">
                </produto-list>
            </div>
        `
    })
